const Cookies = require('js-cookie');


export const cookieConsentGiven = (category) =>
    category && (
        Cookies.get(`cookieyes-${category}`) === 'yes'
            || (Cookies.get('cookieyes-consent') || '').includes(`${category}:yes`)
    );
